import { useEffect, useState } from "react";
import { getPreSignedUrlForDownload } from "../../api/admin";

const ImageAvatar = ({
  imageKey,
  name,
  size = "md",
}: {
  imageKey?: string;
  name: string;
  size?: "sm" | "md";
}) => {
  const [imageUrl, setImageUrl] = useState<string>();

  useEffect(() => {
    if (!imageKey) {
      setImageUrl(undefined);
      return;
    }
    const fetchUrl = async () => {
      const res = await getPreSignedUrlForDownload({ key: imageKey });
      setImageUrl(res.url);
    };
    fetchUrl();
  }, [imageKey]);

  const sizeClasses = size === "sm" ? "h-8 w-8 text-xs" : "h-10 w-10 text-sm";
  const firstLetter = name?.charAt(0)?.toUpperCase() || "?";

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name}
        className={`${sizeClasses} rounded-lg object-cover flex-shrink-0`}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses} rounded-lg bg-primary/10 dark:bg-primary/20 text-primary font-bold flex items-center justify-center flex-shrink-0`}
    >
      {firstLetter}
    </div>
  );
};

export default ImageAvatar;
